/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdateProfileDto = {
    /**
     * User full name
     */
    full_name?: string;
    /**
     * User email address
     */
    email?: string;
    /**
     * Phone number without country code
     */
    phone_number?: string;
    /**
     * Country code with + prefix
     */
    phone_country_code?: string;
    /**
     * Gender
     */
    gender?: UpdateProfileDto.gender;
    /**
     * Date of birth (YYYY-MM-DD)
     */
    date_of_birth?: string;
    /**
     * Profile picture URL
     */
    avatar_url?: string;
};
export namespace UpdateProfileDto {
    /**
     * Gender
     */
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        OTHER = 'other',
    }
}

